<template>
  <div class="" style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class='col-md-8 d-flex flex-row align-center'>
          <v-btn text class="mx-2" :to="this.returnLink">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1><span>PO#{{this.data.poId}} - </span>{{' '+this.singular}} #{{this.data.id}}</h1>
          <v-btn class="ml-2" fab x-small color="info" @click="openPrintDialog()"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
        <v-col class="col-md-4">
          <v-progress-circular
              indeterminate
              color="green"
              v-if="loader"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row v-if="!loader">
        <v-col cols="2" v-if="data.status!==1 && data.status!==-1">
          <v-text-field :disabled="lockPO" id="poIDField" label="Purchase Order #" v-model="poID" @change="fetchPO"/>

          <h3>Products</h3>
          <div style="height:900px; overflow-y: scroll;" class="d-flex flex-column">
            <div v-for="(product, i) in po.purchaseOrderItems" :key="i">
              <div style="padding: 10px; background-color:rgba(0,0,0,0.09); margin-bottom: 3px; border-radius: 7px;" v-if="!product.hidden" class="d-flex flex-row align-center justify-space-between">
                <div>
                  <span>{{product.name}}</span>
                  <br>
                  <span><b>ID:</b> {{product.id}}</span>
                  <br>
                  <span><b>Model #:</b> {{product.sku}}</span>
                  <br>
                  <span><b>Ordered QTY:</b> {{product.quantity}}</span>
                </div>
                <v-btn @click="addProduct(i)" fab x-small color="info"><v-icon>mdi-chevron-right</v-icon></v-btn>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="7">
          <v-card outlined class="pa-10">
            <div class="d-flex flex-row justify-space-between" v-if="po.id">
              <div class="d-flex flex-column" style="width: 50%; margin-bottom: 10px;">
                <div>
                  <span v-if="data.status===-1" class="v-btn warning pa-1" style="font-size: 10px">{{parseStatus(data.status)}}</span>
                  <span v-if="data.status===0" class="v-btn orange pa-1" style="font-size: 10px">{{parseStatus(data.status)}}</span>
                  <span v-if="data.status===1" class="v-btn success pa-1" style="font-size: 10px">{{parseStatus(data.status)}}</span>
                </div>
                <h1 class="d-flex flex-row align-center">Receiving Report</h1>
              </div>
              <div class="d-flex flex-column align-start" style="width: 50%;">
                <h3>Supplier</h3>
                <span v-if="po.supplierInfo.name">{{po.supplierInfo.name}}</span>
                <span v-if="po.supplierInfo.address">{{po.supplierInfo.address}}</span>
                <span v-if="po.supplierInfo.phone">{{po.supplierInfo.phone}}</span>
                <span v-if="po.supplierInfo.email">{{po.supplierInfo.email}}</span>
              </div>
              <div class="d-flex flex-column align-start" style="width: 50%;">
                <h3>Ship To</h3>
                <span v-if="po.shipToInfo.name">{{po.shipToInfo.name}}</span>
                <span v-if="po.shipToInfo.address">{{po.shipToInfo.address}}</span>
                <span v-if="po.shipToInfo.phone">{{po.shipToInfo.phone}}</span>
                <span v-if="po.shipToInfo.email">{{po.shipToInfo.email}}</span>
              </div>
            </div>
            <v-card class="d-flex" :style="(selectedItem && selectedItem.id===item.id?'background: #eeeeee':'')" outlined v-for="(item, i) in data.items" :key="i">
              <v-col>
                {{item.name}}
                <br>
                <b>ID:</b>{{item.id}}
                <br>
                <b>Model #:</b>{{item.sku}}
              </v-col>
              <v-col class="d-flex">
                <v-text-field :min="1" @change="changeQty(i)" type="number" :rules="quantityRules" :disabled="!(data.status!==1 && data.status!==-1)" label="QTY" v-model="data.items[i].quantity"/>
                <v-btn
                    class="mx-2"
                    fab
                    x-small
                    dark
                    color="orange"
                    @click="showLocations(i)"
                >
                  <v-icon>mdi-warehouse</v-icon>
                </v-btn>
                <v-btn v-if="data.status!==1 && data.status!==-1 && item.quantity!==item.qtyToAdd" style="font-size: 10px; width: 20px; height: 20px; margin-left: -20px; margin-top: -8px;" @click="showLocations(i)" fab x-small dark color="blue"><v-icon x-small>mdi-exclamation</v-icon></v-btn>
                <v-btn
                    v-if="data.status!==1 && data.status!==-1"
                    class="mx-2"
                    fab
                    x-small
                    dark
                    color="red"
                    @click="removeProduct(i)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-card>
            <div v-if="data.items.length>0">
              <v-col>
                <v-text-field :disabled="!(data.status!==1 && data.status!==-1)" label="Notes" name="notes" v-model="data.metadata.notes"/>
              </v-col>
            </div>
            <div v-if="data.items.length>0 && data.status===0" style="margin-top: 20px; height: 100px;">
              <v-btn :disabled="data.status===1 || data.status===-1" style="margin-right:5px;" color="error" @click="deleteDraft">Delete Draft</v-btn>
              <v-btn :disabled="allLocationsSet===false || data.status===1 || data.status===-1" style="margin-right:5px;" @click="confirmSaveDialog=true" color="success">Save & Seal</v-btn>
              <v-btn v-if="data.status===1" @click="confirmVoidDialog=true" color="warning">Void Report</v-btn>
              <v-btn v-if="data.status===1" @click="openPrintBarcodeDialog()" color="info" style="margin-left: 5px;" >Print Barcodes</v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="3" v-if="selectedItem">
          <h3>Locations for</h3>
          <span>{{selectedItem.name}}</span>
          <br>
          <b>ID:</b>{{selectedItem.id}}
          <br>
          <b>Model #:</b>{{selectedItem.sku}}
          <br>
          <span v-if="data.status!==1 && data.status!==-1"><b>QTY to Add:</b>{{selectedItem.quantity-selectedItem.qtyToAdd}}</span>
          <br>
          <span class="red--text" v-if="this.selectedItem.qtyToAdd>=this.selectedItem.quantity">Total number of items to have been assigned locations.</span>
          <div style="height:900px; overflow-y: scroll;" class="d-flex flex-column">
            <div v-for="(location, i) in selectedItem.locations" :key="i" class="d-flex flex-row">
              <v-card outlined class="d-flex flex-row pt-2 px-5 mb-2" :style="(((data.status!==1 && data.status!==-1) && location.quantity>0)?'background: #eeeeee;':'')+'width: 100%;'">
                <v-text-field :min="0" @change="updateLocation(i, 0)" type="number" :rules="quantityRules" :disabled="data.status===1 || data.status===-1" :label="location.warehouseName+' '+location.roomName+' QTY'" v-model="location.quantity"/>
                <v-btn v-if="data.status===0" fab small color="success" :disabled="selectedItem.qtyToAdd!==0" @click="updateLocation(i, selectedItem.quantity)"><v-icon>mdi-reply-all</v-icon></v-btn>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        v-model="confirmSaveDialog"
        max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
          Enter your password to confirm this change.
        </v-card-title>
        <v-text-field label="Password" placeholdler="Password" type="password" outlined style="width: 300px; margin: 20px;" v-model="userPassword"></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              text
              @click="confirmSaveDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
              color="success"
              :disabled="!userPassword"
              @click="saveRR"
          >
            Save Report
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="confirmVoidDialog"
        max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
          Enter your password to confirm this change.
        </v-card-title>
        <v-text-field label="Password" placeholdler="Password" type="password" outlined style="width: 300px; margin: 20px;" v-model="userPassword"></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              text
              @click="confirmVoidDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
              color="success"
              :disabled="!userPassword"
              @click="voidRR"
          >
            Void Report
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="printDialog.isOpen"
      width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
          Print Barcodes
        </v-card-title>
        <v-card-text>
          <h3 style="margin: 0px;">Select item to print</h3>
          <hr>
          <v-select
            class="mt-2"
            :items="filteredPrinters"
            item-text="name"
            item-value="id"
            label="Select a Printer"
            v-model="printDialog.printer"
            outlined
          ></v-select>
          <v-text-field style="margin-top: 10px;" dense v-model="printDialog.quantity" type="number" default="1" label="Quantity" outlined></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closePrintDialog()">
            Cancel
          </v-btn>
          <authorizer 
            v-bind:buttontext="'Print'" 
            v-bind:small="true" 
            v-on:response="attemptPrint($event)"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<style>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
<script>
import axios from 'axios';
import {mapGetters} from "vuex";
import authorizer from '../../components/authorizer.vue'
export default {
  components: {
    authorizer
  },
  data () {
    return {
      loader: false,
      printers: [],
      filteredPrinters: [],
      documentTypes: [],
      printDialog: {
        isOpen: false,
        quantity: 1,
        jobType: 'productLabel',
        deliveryNote: '',
        printer: '',
      },
      snackObj: {
        state: false,
        color: '',
        text: ''
      },

      returnLink: '/purchasing',
      max25chars: v => v.length <= 25 || 'Input too long!',
      data: {
        items : [],
        status: 0,
        poId: null,
        employeeId: null,
        metadata: {
          notes: ""
        }
      },
      lockPO: false,
      poID: "",
      po: {
        purchaseOrderItems: []
      },

      quantityRules: [
        v => v>=0 || 'Must be more than or equal 0'
      ],

      allLocationsSet: false,

      warehouses: [],
      rooms: [],
      selectedItem: null,
      locationsNote: "",

      confirmSaveDialog: false,
      confirmVoidDialog: false,
      userPassword: "",
      singular: "Receiving Report",
      singularLower: "receivingreport",
      plural: "Receiving Reports",
      pluralLower: "receivingreports",
      printBarcodeDialog: {
        isOpen: false,
        password: '',
        adminId: ''
      }
    }
  },
  async mounted(){
    try{
      this.loader = true;
      if(this.$route.params.id){
        let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
        if(res.data.error) throw res.data.error

        this.data = res.data.data;

        let data = await axios.get(`${this.getEndpoint}/api/warehouses/withRooms`)
        if(data.data.error) throw data.data.error
        this.warehouses = data.data.data;

        this.poID = this.data.poId;

        let po = await axios.get(`${this.getEndpoint}/api/purchaseorders/${this.poID}`)
        if(po.data.error) throw po.data.error

        this.po = po.data.data;
        if(!this.po.purchaseOrderItems) throw "This PO has no items.";
        if(!this.po.shipToInfo) this.po.shipToInfo = {};
        this.data.poId = this.po.id;
        this.lockPO = true;

        this.returnLink = `/purchaseorders/view/${this.po.id}`;

        if(!this.data.items) this.data.items = [];

        this.data.items.forEach(item => {
          let poItem = this.po.purchaseOrderItems.find(val => {
            return val.id===item.id;
          });

          poItem.hidden = true;
        });
        this.checkAllLocations();
        let userPrinters = this.getUser.metadata.printers
        let printers = await axios.get(`${this.getEndpoint}/api/devices/`)
        if(!printers.data.error){
          this.documentTypes = printers.data.data.documentTypes
          let printerDeviceTypeId = (printers.data.data.deviceTypes.filter(x=>x.name.toLowerCase()==='printer')[0]).id //looks at the deviceType object from the response to determine the id of the printers device type
          this.printers = printers.data.data.devices.filter(x=>x.deviceType===printerDeviceTypeId)
          this.printers.forEach(printer=>{
            for(let y in userPrinters.default){
              if(printer.data.jobTypes.includes(y)){
                if(printer.id==userPrinters.default[y]){
                  printer['isDefault'] = true
                  printer.name = printer.name + ` (Default ${y} printer)`
                }else printer['isDefault'] = false
              }
            }
          })
          this.filteredPrinters = this.printers
        }
        return;
      }
      await this.$router.push({path: `/purchasing`})
    }
    catch (error) {
      console.error(error)
      this.snack(error.msg || error, "error");
    }
    finally {
      this.loader = false;
    }
  },
  computed: {
    ...mapGetters(['getId', 'getEndpoint', "isAllowed", "getUser"])
  },
  methods: {
    openPrintDialog(){
      this.printDialog.isOpen = true
    },
    closePrintDialog(){
      this.printDialog = {
        isOpen: false,
        quantity: 1,
        jobType: '',
        deliveryNote: '',
        printer: ''
      }
    },
    async attemptPrint(e){
      try {
          if(!e.pin&&!e.vsidToken) throw "Error Getting Credentials"
          e.metadata = this.printDialog
          let res = await axios.post(`${this.getEndpoint}/api/print/productLabelsForRR/${this.$route.params.id}`, e)
          if(res.data.error) throw res.data.error
          this.closePrintDialog()
      } catch (error) {
        console.log(error)
        this.snack(error)
        this.closePrintDialog()
      }
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.state = true;
      this.snackObj.color = color;
    },
    openPrintBarcodeDialog(){
      this.printBarcodeDialog.isOpen = true
    },
    cancelBarcodeDialog(){
      this.printBarcodeDialog.isOpen = false
      this.printBarcodeDialog.password = ""
    },
    async attemptBarcodePrint(){
      try {
        this.printBarcodeDialog.adminId = this.getId
        let res = await axios.post(`${this.getEndpoint}/api/products/printBarcodesForReceivingReport/${this.$route.params.id}`, this.printBarcodeDialog)
        if(res.data.error) throw res.data.error

        this.snack("Print Job Successfully Posted.")
        this.cancelBarcodeDialog()
      } catch (error) {
        console.log(error)
        this.snack(error.msg || error, "error");
      }
    },
    createDefaultLocations(){
      let locations = [];

      this.warehouses.forEach(warehouse => {
        warehouse.Rooms.forEach(room => {
          let obj = {
            roomId: room.id,
            warehouseName: warehouse.name,
            roomName: room.name,
            quantity: 0
          }

          locations.push(obj);
        });
      });

      return locations;
    },
    showLocations(i){
      this.selectedItem = this.data.items[i];
    },
    addProduct(i){
      let newLocations = this.createDefaultLocations();

      let item = {
        id: this.po.purchaseOrderItems[i].id,
        name: this.po.purchaseOrderItems[i].name,
        sku: this.po.purchaseOrderItems[i].sku,
        type: this.po.purchaseOrderItems[i].type,
        quantity: 1,
        maxQuantity: this.po.purchaseOrderItems[i].quantity,
        locations: newLocations,
        qtyToAdd: 0,
        trueIndex: i
      };

      this.data.items.push(item);

      this.po.purchaseOrderItems[i].hidden = true;

      this.saveDraft();
    },
    removeProduct(i){
      this.po.purchaseOrderItems[this.data.items[i].trueIndex].hidden = false;
      if(this.selectedItem && this.selectedItem.id===this.data.items[i].id){
        this.selectedItem = null;
      }
      this.data.items.splice(i, 1);
    },
    changeQty(i){
      this.data.items[i].quantity=parseInt(this.data.items[i].quantity);
      this.data.items[i].locations = this.createDefaultLocations();
      this.data.items[i].qtyToAdd = 0;

      if(this.data.items[i].quantity<1){
        this.data.items[i].quantity=parseInt(1);
        this.snack("Quantity must be at least 1.")
      }
      if(this.data.items[i].quantity>this.data.items[i].maxQuantity){
        this.data.items[i].quantity=parseInt(this.data.items[i].maxQuantity);
        this.snack(`Quantity cannot surpass ordered amount. (MAX: ${this.data.items[i].maxQuantity})`)
      }

      this.checkAllLocations();
      this.saveDraft();
    },
    updateLocation(i, qty){
      if(qty===0){
        this.selectedItem.locations[i].quantity = parseInt(this.selectedItem.locations[i].quantity);

        let total = 0;
        for(let location of this.selectedItem.locations){
          total+=location.quantity;
        }

        this.selectedItem.qtyToAdd = total;
        if(total>this.selectedItem.quantity){
          let without = this.selectedItem.quantity-(total-this.selectedItem.locations[i].quantity)
          this.selectedItem.qtyToAdd=this.selectedItem.quantity;
          this.selectedItem.locations[i].quantity = without;
          this.snack("Total surpassed. Quantity adjusted.")
        }
      }
      else{
        if(this.selectedItem.qtyToAdd+qty>this.selectedItem.quantity || this.selectedItem.locations[i].quantity+qty<0) return;
  
        this.selectedItem.locations[i].quantity=parseInt(this.selectedItem.locations[i].quantity)+qty;
        this.selectedItem.qtyToAdd=parseInt(this.selectedItem.qtyToAdd)+qty;
      }

      this.checkAllLocations();
      this.saveDraft();
    },
    checkAllLocations(){
      for(let item of this.data.items){
        if(item.quantity!==item.qtyToAdd){
          this.allLocationsSet = false;
          return;
        }
      }
      this.allLocationsSet = true;
    },
    async fetchPO(){
      try{
        if(!this.poID) return;
        let res = await axios.get(`${this.getEndpoint}/api/purchaseorders/${this.poID}`)
        if(res.data.error) throw res.data.error

        if(res.data.status!==1) throw `PO#${this.poID} is not sealed.`

        this.po = res.data.data;
        this.data.poId = this.po.id;
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
        await this.$router.push({ path: this.returnLink});
      }
    },
    async saveDraft(){
      try{
        this.data.employeeId = this.getId;
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}`, this.data)
        if(res.data.error) throw res.data.error
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
    },
    async deleteDraft(){
      try {
        this.data.employeeId = this.getId;
        let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.data.id}`)
        if (res.data.error) throw res.data.error

        this.snack(`Report deleted.`, "success")
        await this.$router.go(-1);
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
    },
    async saveRR(){
      try{
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/save/${this.data.id}`, {password: this.userPassword})
        if(res.data.error) throw res.data.error

        this.data = res.data.data;
        if(this.selectedItem){
          this.selectedItem = this.data.items.find(x => {
            return this.selectedItem.id === x.id;
          });
        }
        this.snack(`Report sealed.`, "success")
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
      finally {
        this.userPassword = "";
        this.confirmSaveDialog = false;
      }
    },
    async voidRR(){
      try{
        let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/void/${this.data.id}`, {password: this.userPassword})
        if(res.data.error) throw res.data.error

        this.data.status = -1;
        this.snack(`Report voided.`, "success")
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error");
      }
      finally {
        this.userPassword = "";
        this.confirmVoidDialog = false;
      }
    },
    parseStatus(id){
      if(id===-1) return "Voided"
      else if(id===0) return "Draft"
      else if(id===1) return "Sealed"
    }
  }
}
</script>
